/** Type for CategoryBox width, more info in documentation for enum values. */
export let CategoryBoxSize = /*#__PURE__*/function (CategoryBoxSize) {
  CategoryBoxSize["SMALL"] = "small";
  CategoryBoxSize["MEDIUM"] = "medium";
  CategoryBoxSize["LARGE"] = "large";
  return CategoryBoxSize;
}({});
//# sourceMappingURL=types.js.map